var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPowerSupply(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 512,
    height: 512,
    viewBox: "0 0 512 512",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 76,
    y: 76,
    width: 360,
    height: 360,
    rx: 180,
    stroke: "#5f9098",
    strokeWidth: 40
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M322.603 226.529C322.277 225.859 321.769 225.295 321.137 224.9C320.505 224.505 319.775 224.295 319.029 224.296H277.656L310.706 154.658C310.993 154.054 311.122 153.387 311.082 152.72C311.041 152.053 310.832 151.407 310.474 150.842C310.115 150.277 309.62 149.812 309.033 149.49C308.446 149.168 307.787 148.999 307.117 149H243.588C242.823 149 242.073 149.221 241.43 149.636C240.787 150.052 240.278 150.644 239.965 151.341L188.348 266.266C188.076 266.87 187.961 267.531 188.012 268.191C188.062 268.85 188.278 269.487 188.638 270.042C188.998 270.597 189.492 271.053 190.074 271.369C190.656 271.685 191.308 271.851 191.971 271.851H230.721L211.915 358.191C211.723 359.067 211.835 359.982 212.231 360.787C212.628 361.592 213.287 362.238 214.099 362.621C214.912 363.004 215.83 363.1 216.705 362.894C217.579 362.689 218.358 362.193 218.914 361.488L322.148 230.712C322.609 230.127 322.897 229.425 322.977 228.685C323.057 227.946 322.928 227.198 322.603 226.529Z",
    fill: "#5f9098"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPowerSupply);
export default __webpack_public_path__ + "static/media/powerSupply.00221331355b6a1e6cda3aacaf864cef.svg";
export { ForwardRef as ReactComponent };